<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Sad" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
	.stSad1{fill:#302C3B;}
	.stSad2{fill:#57CCF2;}
	.stSad3{fill:#FDCA47;enable-background:new    ;}
	.stSad4{fill:#302C3B;enable-background:new    ;}
</style>
	<circle class="stSad1" cx="335.6" cy="208" r="32"/>
	<path class="stSad2" d="M153.6,291.3c3.2-4.4,9.6-4.4,12.8,0C179.6,308.6,208,349,208,369c0,26-21.5,47-48,47s-48-21-48-47
	C112,349,140.6,308.6,153.6,291.3L153.6,291.3z"/>
	<circle class="stSad1" cx="175.6" cy="208" r="32"/>
	<path class="stSad3" d="M256,0c141.4,0,256,114.6,256,256S397.4,512,256,512S0,397.4,0,256S114.6,0,256,0z M256,352
	c34.9,0,67.2,15.8,92.3,42.9c6,6.5,16.1,6.8,22.6,0.8s6.8-16.1,0.8-22.6C341.6,340.5,301,320,256,320c-8.8,0-16,7.2-16,16
	S247.2,352,256,352L256,352z M208,369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8,0C140.6,308.6,112,349,112,369
	c0,26,21.5,47,48,47S208,395,208,369L208,369z M303.6,208c0,17.7,13.5,32,32,32c17.7,0,32-14.3,32-32s-14.3-32-32-32
	C317.1,176,303.6,190.3,303.6,208z M207.6,208c0-17.7-14.3-32-32-32c-18.5,0-32,14.3-32,32s13.5,32,32,32
	C193.3,240,207.6,225.7,207.6,208z"/>
	<path class="stSad4" d="M256,352c34.9,0,67.2,15.8,92.3,42.9c6,6.5,16.1,6.8,22.6,0.8s6.8-16.1,0.8-22.6C341.6,340.5,301,320,256,320
	c-8.8,0-16,7.2-16,16S247.2,352,256,352L256,352z"/>
</svg>